// extracted by mini-css-extract-plugin
module.exports = {"container":"shared_container__1cT4l","button":"shared_button__2xeSP"};